import React, { Component, Fragment } from "react";
import CircleArcHolder from "./section2/circleArcHolder";
import Spinner from "../../Datatable/spinner/spinner";
import AnnualizedBacktest from './section1/annualizedBacktest';
import $ from "jquery";

class Growth extends Component {
  state = {
    res: {},
    spinner: false,
    data: [],
    initialWidth: 0
  };

  componentDidMount() {
    var res = this.props.getBacktest;
    var barChartData = this.props.getPerfHistMetrics;

    let LayoutWidth = $(".container-wrapper").width() - 30;
    let initialWidth = (LayoutWidth / 100) * 53;

    if (res) {
      this.setState({ res, data: barChartData, initialWidth });
    }
  }

  render() {
    const { spinner, res, data,initialWidth } = this.state;
    return (
      <div className="row">
        {spinner ? <Spinner /> : null}
        {Object.keys(res).length > 0 ? (
          <Fragment>
            <div className="col-lg-7 col-md-7 col-sm-12 col-xs-12">
              {initialWidth > 0 ? <AnnualizedBacktest
                data={data}
                spinner={spinner}
                initialWidth={initialWidth}
                {...this.props}
              /> : null }
            </div>

            <Fragment>
              {/*line chart been commented below  */}
              {/* <PortfolioGrowth res={res} {...this.props} /> */}
              {res.getPortfolioVami.length && res.getBenchmarkVami.length ? (
                <CircleArcHolder res={res} {...this.props} />
              ) : null}
            </Fragment>

            {/* <div style={{ paddingLeft: "15px" }}>Error in loading data</div> */}
          </Fragment>
        ) : null}
      </div>
    );
  }
}

export default Growth;



// WEBPACK FOOTER //
// ./src/components/PortfolioDashboard/navigationPages/backtest/growth/growth.jsx